<template>
    <div class="row pricing-table-one">
        <div class="col-md-6 col-xl-3 pricing-table wow move-up" v-for="(pricing, index) in pricingTable" :key="index" :class="{'pricing-table--popular__bg': pricing.active}">
            <div class="pricing-table__inner" :class="{'bg-gradient': pricing.active}">
                <div class="pricing-table__feature-mark" v-if="pricing.isPopular">
                    <span>{{$t('populer')}}</span>
                </div>
                <div class="pricing-table__header">
                    <div class="pricing-table__image">
                        <img :src="pricing.thumb" class="img-fluid" :alt="pricing.alt">
                    </div>
                    <h5 class="pricing-table__title">{{ $t(pricing.title) }}</h5>
                    <div class="pricing-table__price-wrap">
                        <h6 class="currency">&#8378;</h6>
                        <h6 class="price">{{ pricing.value }}</h6>
                        <h6 class="period">/{{ $t(pricing.duration) }}</h6>
                    </div>
                </div>
                <div class="pricing-table__body">
                    <ul class="pricing-table__list">
                        <li v-for="(list, index) in pricing.price" :key="index">{{ $t(list) }}</li>
                    </ul>
                </div>
                <div class="pricing-table__footer">
                    <a href="#" class="ht-btn ht-btn--outline ht-btn-default" :class="{'btn--white': pricing.active}">{{ $t('simdidene') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PricingOne',
        data (){
            return {
                pricingTable: [
                    {
                        thumb: require('../assets/img/pricing/KarpinMobile.webp'), 
                        title: 'Karpin Mobil',
                        value: '22990',
                        duration: 'sinirlierisim',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: false,
                        price: ["mobilmodul"]
                    },
                    {
                        thumb: require('../assets/img/pricing/KarpinPos.webp'),
                        title: 'posyazilimi',
                        value: '16995',
                        duration: 'lisans',
                        alt: 'Pricing Thumb',
                        isPopular: true,
                        active: true,
                        price: ['posmodul']
                    },
                    {
                        thumb: require('../assets/img/pricing/KarpinMarket.webp'),
                        title: 'marketyazilimi',
                        value: '29950',
                        duration: 'lisans',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: false,
                        price: ['marketmodul']
                    },
                    {
                        thumb: require('../assets/img/pricing/KarpinPerakende.webp'),
                        title: 'magazayazilimi',
                        value: '24950',
                        duration: 'lisans',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: false,
                        price: ['magazamodul']
                    }
                ]
            }
        }
    }
</script>